import { EyeIcon, XIcon } from "lucide-react"
import { usePostHog } from "posthog-js/react"
import { Alert, AlertDescription } from "~/components/ui/alert"
import { TooltipButton } from "~/components/ui/button"
import { usePermission } from "~/hooks/usePermission"
import { usePermissionPreview } from "~/hooks/usePermissionPreview"

export function RolePreviewControl() {
	const preview = usePermissionPreview()
	const { previewRole } = usePermission()
	const posthog = usePostHog()
	if (!preview || !previewRole) return null
	return (
		<RolePreviewAlert
			roleName={previewRole}
			onStop={() => {
				posthog.capture("role_preview_stopped", {
					scope: preview.selection?.scope,
					scope_id: preview.selection?.scopeId
				})
				preview.setSelection(null)
			}}
		/>
	)
}

export function RolePreviewAlert({
	roleName,
	onStop
}: {
	roleName: string
	onStop: () => void
}) {
	return (
		<Alert variant="info" density="compact" role="status">
			<AlertDescription className="w-full min-w-0">
				<div className="flex w-full min-w-0 items-center gap-2">
					<EyeIcon className="size-4 shrink-0" />
					<div
						className="min-w-0 grow"
						title={`You are currently viewing as ${roleName}`}
					>
						<span className="block truncate">You are currently viewing as</span>
						<strong className="block truncate font-medium">{roleName}</strong>
					</div>
					<TooltipButton
						tooltip="Stop viewing as role"
						aria-label={`Stop viewing as ${roleName}`}
						variant="ghost"
						size="icon-xs"
						onClick={onStop}
					>
						<XIcon />
					</TooltipButton>
				</div>
			</AlertDescription>
		</Alert>
	)
}
